// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"p2-z","displaySixCardTiles":"q2-z"};